<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>FAQ</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                {{ id_faq != null ? 'Edit' : 'Tambah' }} FAQ
                            </h2>
                        </div>
                        <div class="body">
                            <form class="form-horizontal" v-on:submit.prevent="save">
                              <div class="row clearfix">
                                  <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                    <label for="kategori">Kategori</label>
                                  </div>
                                  <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                    <div class="form-group">
                                      <div class="form-line">
                                        <select v-model="data.kategori" class="form-control">
                                          <option disabled value="">-- Pilih Kategori --</option>
                                            <option v-for="item in categories" :key="item.id" :value="item.id">
                                            {{ item.category }}
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="pertanyaan">Pertanyaan</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="pertanyaan" type="text" v-model="data.pertanyaan"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="jawaban">Jawaban</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <Ckeditor id="jawaban" v-model="data.jawaban" :config="config"></Ckeditor>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                        <button v-bind:disabled="isLoading" v-if="id_faq" @click="update" type="button" class="btn btn-warning waves-effect waves-button" v-waves.button>
                                            <span v-if="!isLoading"><i class="material-icons">save</i> Edit</span>
                                            <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                                        </button>
                                        <button v-bind:disabled="isLoading" v-else @click="save" type="button" class="btn btn-primary waves-effect waves-button" v-waves.button>
                                            <span v-if="!isLoading"><i class="material-icons">save</i> Simpan</span>
                                            <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                                        </button>
                                        <button @click="$router.go(-1)" type="button" class="btn btn-danger waves-effect waves-button" v-waves.button><i class="material-icons">cancel</i> Batal</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
/* eslint-disable */

  import Ckeditor from 'vue-ckeditor2'
  import FormLine from '@/components/FormLine.vue'
  import api from '@/helper/api'

  export default {
    components: {FormLine, Ckeditor},
    name: 'FormFaq',
    data: function () {
      return {
        config: {
          toolbar: [
            { name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
            { name: 'morestuff', items: ['NumberedList', 'BulletedList'] },

            { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] },
            { name: 'colors', items: ['TextColor'] },
            { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] },
            '/',
            { name: 'document', items: ['Source'] }
          ],
          height: 300
        },
    data: {
      kategori: '',       
      pertanyaan: '',     
      jawaban: ''        
    },
        categories:'',
        gambar: '',
        id_faq: '',
        isLoading: false
      }
    },
    methods: {
      save () {
        this.isLoading = true
        const payload = {
        pertanyaan: this.data.pertanyaan,
        jawaban: this.data.jawaban,
        faqCategoryId: this.data.kategori
        }
        console.log(payload)
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.post('/saveFaq', payload).then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/faq')
            this.$toastr.s('Tambah data berhasil')
          } else {
            var msg = 'Tambah data gagal'
            if (result.data.message !== '') msg = result.data.message
            this.$toastr.e(msg)
          }
          this.isLoading = false
        }).catch(e => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
      },
      update () {
          const payload = {
           idFaq: this.id_faq,
           pertanyaan: this.data.pertanyaan,
           jawaban: this.data.jawaban,
           faqCategoryId: this.data.kategori
         }
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.post('/updateFaq/' + this.id_faq, payload).then((result) => {
          if (result.status === 200) {
            this.$router.replace('/main/faq')
            this.$toastr.s('Ubah data berhasil')
          }
        }).catch((ex) => {
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
        })
      },
getDetail () {
  api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
  api.get('/faq/' + this.id_faq).then((result) => {
    const res = result.data

    this.data = {
      kategori: res.faqCategory.id,
      pertanyaan: res.pertanyaan,
      jawaban: res.jawaban
    }
  }).catch((ex) => {
    this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
  })
},
      getCategories () {
      api.defaults.headers.common['Authorization'] =
        'Bearer ' + localStorage.getItem('_token')
      api
      .get('/getALLFaqCategory')
      .then((res) => {
        this.categories = res.data.content
        console.log( "ini categories",this.categories)
      })
      .catch((err) => {
        this.$toastr.e('Gagal mengambil data kategori')
        console.error(err)
      })
    },
      handleFile (file) {
        this.file = file.target.files[0]
      }
    },
    mounted () {
      this.id_faq = this.$route.params.id
      this.getCategories()

      if (this.id_faq != null) {
        this.getDetail()
      }

    }
  }
</script>


// WEBPACK FOOTER //
// src/view/Faq/FormFaq.vue?8adf6cd0